<template>
  <div class="container introuvable">
    <h1>Page introuvable</h1>
    <div class="row blocs_introuvable">
      <div class="col-sm-6 col-12">
        <img id="image_404" src="../assets/colibri-404.png" alt="404" />
      </div>
      <div class="col-sm-6 col-12 bloc_texte">
        <p id="texte_404">L'adresse URL insérée n'existe pas</p>
        <div class="div_lien">
          <router-link class="lien" :to="{ name: 'accueil' }"> Accueil </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss">
@import '../sass/app';

.blocs_introuvable {
  display: flex;

  #image_404 {
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 3rem;
  }

  .bloc_texte {
    margin: auto;

    #texte_404 {
      text-align: center;
      font-size: 25px !important;
      padding: 3rem;
      @include media-breakpoint-down(sm) {
        padding: 1rem;
      }
    }

    .div_lien {
      display: flex;

      .lien {
        margin: auto;
        color: $secondcolor;
        text-align: center;
        font-size: 25px;
      }

      .lien:hover {
        color: $firstcolor;
        text-decoration: none;
      }
    }
  }
}
</style>